import {startTransition, useCallback, useEffect, useRef} from 'react'
import {useHistory} from 'react-router-dom'
import {scheduleAfterPaint} from '../utils/common-utils'

const isBrowserHandledNavigation = (event) =>
    event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey

export default function useDeferredNavigation({spinnerRef, fallbackHideDelay = 1500} = {}) {
    const history = useHistory()
    const hideTimerRef = useRef(null)

    useEffect(() => {
        return () => {
            if (hideTimerRef.current) {
                window.clearTimeout(hideTimerRef.current)
            }
        }
    }, [])

    return useCallback(
        (event, path, beforeNavigate) => {
            if (!path || event.defaultPrevented) {
                return false
            }

            if (isBrowserHandledNavigation(event)) {
                beforeNavigate?.()
                return false
            }

            event.preventDefault()
            spinnerRef?.current?.classList?.remove('hide-element')
            beforeNavigate?.()

            // Use requestAnimationFrame to prioritize navigation after paint.
            // This ensures the browser can paint click feedback and spinner
            // before route transition starts, reducing INP especially under CPU throttle.
            scheduleAfterPaint(() => {
                startTransition(() => history.push(path))
            })

            if (spinnerRef?.current) {
                if (hideTimerRef.current) {
                    window.clearTimeout(hideTimerRef.current)
                }

                hideTimerRef.current = window.setTimeout(() => {
                    spinnerRef.current?.classList?.add('hide-element')
                }, fallbackHideDelay)
            }

            return true
        },
        [fallbackHideDelay, history, spinnerRef]
    )
}
